// extracted by mini-css-extract-plugin
module.exports = {"user":"TextUser_user__RXt2n","namePlaceholder":"TextUser_namePlaceholder__2dnzR"};